export enum MenuItemType {
  REWARD_SHOP = 'rewardShop',
  BOOSTERS = 'boosters',
  HISTORY = 'history',
}
